export default __webpack_public_path__ + "static/media/cx_cover_tln1.e33ded76.jpg";